"use client";

import { XMarkIcon } from "@heroicons/react/24/solid";
import dayjs from "dayjs";
import { useState } from "react";

import { BannerData } from "@/app/api/sales-event/banner/schema";
import { useLang } from "@/hooks/use-lang";

type Props = {
  bannerInfo: BannerData;
};

const checkIsWithinEventPeriod = (start: string, end: string) => {
  const today = dayjs();
  const startDate = dayjs(start).startOf("day");
  const endDate = dayjs(end).endOf("day");

  return today.isAfter(startDate) && today.isBefore(endDate);
};

export const EventBannerInfo = ({ bannerInfo }: Props) => {
  const { lang } = useLang();
  const [isShowBanner, setIsShowBanner] = useState(true);

  const isWithinEventPeriod = checkIsWithinEventPeriod(
    bannerInfo.startDate,
    bannerInfo.endDate
  );

  const handleClickBanner = () => {
    if (bannerInfo?.link) {
      window.open(bannerInfo.link, "_blank");
    }
  };

  const handleClickClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsShowBanner(false);
  };

  return (
    <>
      {isShowBanner && isWithinEventPeriod && (
        <div
          id="event-banner"
          className="relative z-[99999] h-10 cursor-pointer bg-yellow-500 duration-300 hover:bg-yellow-400"
          onClick={handleClickBanner}
        >
          <div className="flex h-full items-center justify-center px-10">
            <span className="text-center text-sm font-bold text-[#BE4400] sm:text-base">
              {bannerInfo.text[lang]}
            </span>
            <button
              className="absolute right-5 rounded-full p-1 hover:bg-white hover:bg-opacity-20"
              onClick={handleClickClose}
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};
